export default "__VITE_ASSET__COGvxEaZ__"